import { post } from '../axios'

// 查询配置信息（C端）
export function payMethod_queryConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_PAYMETHOD}/payMethod/queryConfig`,
    map,
    option
  ).then(response => response)
}

// 刪除配置信息
export function payMethod_deleteConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_PAYMETHOD}/payMethod/deleteConfig`,
    map,
    option
  ).then(response => response)
}

// 配置信息列表
export function payMethod_listConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_PAYMETHOD}/payMethod/listConfig`,
    map,
    option
  ).then(response => response)
}

// 保存配置信息
export function payMethod_saveConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_PAYMETHOD}/payMethod/saveConfig`,
    map,
    option
  ).then(response => response)
}

// 更改排序
export function payMethod_changeSort_post(map, option) {
  return post(
    `${process.env.VUE_APP_PAYMETHOD}/payMethod/changeSort`,
    map,
    option
  ).then(response => response)
}
